<template>
  <div>
    <v-card-actions>
      <v-row>
        <v-col>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                outlined
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>{{ icons.mdiMenu }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="showTranfRoom()">
                <v-list-item-title>Transferir Quarto</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showTranfItens()">
                <v-list-item-title>Transferir Itens</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showTranfDiarias()">
                <v-list-item-title>Transferir Diárias</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showEditCheckout()">
                <v-list-item-title>Editar Diárias</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showExtraDialog()">
                <v-list-item-title>Tarifas Extraordinárias</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showDialogConsumption()">
                <v-list-item-title>Consumo Hóspede</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showDialogObs()">
                <v-list-item-title>Adcionar Observação</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showdialogChangeLicensePlate()">
                <v-list-item-title>Alterar Placa Veículo</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showCancelDialog()">
                <v-list-item-title class="custom-title">
                  Cancelar CheckIn
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- <v-btn x-large color="secondary" @click="showTranfRoom()" class="mr-4">Transferir Quarto</v-btn>
                <v-btn x-large color="secondary" @click="showEditCheckout()" class="mr-4">Checkout</v-btn> -->
        </v-col>
        <v-col class="text-right">
          <v-btn
            x-large
            color="orange"
            class="white--text"
            @click="showOutstanding()"
          >
            Salvar conta avulsa
          </v-btn>
          <v-btn
            x-large
            color="warning"
            class="ml-2"
            @click="partialPayment()"
          >
            adiantamento
          </v-btn>
          <v-btn
            x-large
            color="success"
            class="ml-2"
            @click="closeAccount()"
          >
            Encerrar Conta
          </v-btn>
        </v-col>
        <!-- <v-col class="text-right">
                <v-btn class="mr-4" x-large text @click="dialogRoom=false">Fechar</v-btn>
                <v-btn color="primary" x-large :loading="editedItemLoading" @click="save()">Salvar</v-btn>
            </v-col> -->
      </v-row>
    </v-card-actions>
    <v-card-text class="mt-4">
      <v-row>
        <v-col cols="8">
          <v-tabs
            v-model="tab"
            background-color="secondary"
            outlined
          >
            <v-tab>Produtos</v-tab>
            <v-tab>Serviços</v-tab>
            <v-tab>Hóspedes</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- TABELA PRODUTOS  -->
            <v-tab-item>
              <v-card outlined>
                <v-data-table
                  :headers="headers"
                  disable-sort
                  :items="itemsProducts"
                  item-key="__rowKey"
                  sort-by="calories"
                  class="elevation-0"
                  :footer-props="{
                    itemsPerPageText: 'Itens por pagina',
                    itemsPerPageOptions: [5],
                    showFirstLastPage: true,
                  }"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Produtos</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <!-- <v-spacer></v-spacer> -->
                      <autocomplete-search-product
                        v-model="product"
                        :dense="true"
                        class="mt-7"
                      />
                      <v-btn
                        class="ml-2"
                        color="primary"
                        :disabled="!product"
                        @click="dialogQtyProduct()"
                      >
                        <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar
                      </v-btn>
                      <v-btn
                        color="secondary"
                        :loading="loadingPrintProduct"
                        :disabled="loadingPrintProduct"
                        class="ml-2"
                        @click="sendPrintProduct()"
                      >
                        Imprimir Pedidos
                      </v-btn>
                      <v-btn
                        text
                        color="secondary"
                        class="ml-2"
                        @click="showPrintCommands()"
                      >
                        <v-icon left>
                          {{ icons.mdiHistory }}
                        </v-icon>
                        Comandas
                      </v-btn>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.print>
                    <v-btn
                      v-if="hasPrinters"
                      icon
                      color="secondary"
                      :loading="loadingPrintProduct"
                      @click="showPrintCommands()"
                    >
                      <v-icon>{{ icons.mdiPrinter }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      icon
                      large
                      color="error"
                      @click="dialogRemoveProduct(item)"
                    >
                      <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{ formatMoney(calcTotalProduct(item)) }}
                  </template>
                  <template v-slot:item.pdv="{ item }">
                    {{ pdvDescription(item.pivot.pdv_id) }}
                  </template>
                  <template v-slot:item.qty="{ item }">
                    {{ formatMoney(item.pivot.quantity) }}
                  </template>
                  <template v-slot:item.sale_price="{ item }">
                    {{ formatMoney(item.sale_price) }}
                  </template>
                  <template v-slot:foot="{ item }">
                    <tr
                      style="height:44px; background:#fafafa"
                      class=""
                    >
                      <td
                        colspan="3"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6;padding-left:16px;padding-right:16px"
                      >
                        <b>TOTAL:</b>
                      </td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6 ;padding-left:16px;padding-right:16px"
                      >
                        <b>{{ formatMoney(calcTotalProductAmount) }}</b>
                      </td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <!-- TABELA SERVIÇOS -->
            <v-tab-item>
              <v-card outlined>
                <v-data-table
                  :headers="headers_service"
                  :items="itemsServices"
                  item-key="__rowKey"
                  disable-sort
                  class="elevation-0"
                  :footer-props="{
                    itemsPerPageText: 'Itens por pagina',
                    itemsPerPageOptions: [5],
                    showFirstLastPage: true,
                  }"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Serviços</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <!-- <v-spacer></v-spacer> -->
                      <AutocompleteSearchService
                        v-model="service"
                        :dense="true"
                        class=""
                      ></AutocompleteSearchService>
                      <v-btn
                        class="ml-2"
                        color="primary"
                        :disabled="!service"
                        @click="showDialogQtyService()"
                      >
                        <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar
                      </v-btn>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      icon
                      large
                      color="error"
                      @click="dialogRemoveService(item)"
                    >
                      <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{ formatMoney(calcTotalService(item)) }}
                  </template>
                  <template v-slot:item.qty="{ item }">
                    {{ formatMoney(item.pivot.quantity) }}
                  </template>
                  <template v-slot:item.sale_price="{ item }">
                    {{ formatMoney(item.sale_price) }}
                  </template>
                  <template v-slot:foot="{ item }">
                    <tr
                      style="height:44px; background:#fafafa"
                      class=""
                    >
                      <td
                        colspan="2"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6;padding-left:16px;padding-right:16px"
                      >
                        <b>TOTAL:</b>
                      </td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6 ;padding-left:16px;padding-right:16px"
                      >
                        <b>{{ formatMoney(calcTotalServiceAmount) }}</b>
                      </td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <!-- TABELA HOSPEDES -->
            <v-tab-item>
              <v-card outlined>
                <TableGuestBusy
                  :guests="guests"
                  @updateGuests="updateGuest"
                ></TableGuestBusy>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
        <v-col cols="4">
          <v-card
            elevation="0"
            outlined
            style="height:453px"
          >
            <v-card-text>
              <h3>Dados da conta</h3>
              <v-row>
                <v-col>
                  <v-row no-gutters>
                    <v-col>Reserva ID:</v-col>
                    <v-col class="text-right">
                      {{ room.current_reserve_id }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Comanda ID:</v-col>
                    <v-col class="text-right">
                      {{ room.current_accommodation_id }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Veículo placa:</v-col>
                    <v-col class="text-right">
                      {{ licensePlate }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Origem:</v-col>
                    <v-col class="text-right">
                      {{ (room.current_accommodation.company ?
                        room.current_accommodation.company.fantasy_name : '*****').substring(0, 20) }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <h3 class="mt-6">
                Dados da conta
              </h3>
              <v-row>
                <v-col>
                  <v-row no-gutters>
                    <v-col>Valor quarto:</v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col>Valor Consumo:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Impostos:</v-col>
                  </v-row>
                </v-col>

                <v-col>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      R$ {{ formatMoney(room.totalRoomCurrent) }}
                    </v-col>
                  </v-row>
                  <v-row
                    class="text-right"
                    no-gutters
                  >
                    <v-col> R$ {{ formatMoney(room.consumption) }}</v-col>
                  </v-row>
                  <v-row
                    class="text-right"
                    no-gutters
                  >
                    <v-col> R$ {{ formatMoney(getTaxation) }}</v-col>
                  </v-row>
                </v-col>
              </v-row>

              <h3 class="mt-6">
                Resumo da estadia
              </h3>
              <v-row>
                <v-col>
                  <v-row no-gutters>
                    <v-col>Entrada:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Saída Limite:</v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col>Permanência:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Permanência em horas:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Desconto:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Outros acréscimos:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col><b>Total da conta:</b></v-col>
                  </v-row>
                </v-col>

                <v-col>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      {{ formatDateTime(room.current_accommodation.date_checkin) }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      {{ formatDateTime(room.prev_checkout) }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      {{ room.current_accommodation.permanence }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      {{ room.current_accommodation.permanence_hours }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      R$ 0,00
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      R$ 0,00
                    </v-col>
                  </v-row>
                  <v-row
                    class="text-right"
                    no-gutters
                  >
                    <v-col> <b> R$ {{ formatMoney(getTotalToPay) }}</b></v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card
            class="my-2"
            elevation="0"
            outlined
          >
            <v-card-text>
              <h3 class="mb-2">
                Observações:
              </h3>
              <v-row>
                <v-col>
                  <span v-text="roomObs"></span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- DIALOG ADICIONAR PRODUTO -->
      <v-dialog
        v-model="dialogQty"
        width="500"
      >
        <v-card>
          <BarTitleDialog
            title="quantidade"
            @close="dialogQty = false"
          />
          <v-card-text>
            <v-row
              no-gutters
              style="height:90px"
            >
              <v-col cols="8">
                <!-- <v-text-field label="Quantidade" v-model="qtyProduct" outlined></v-text-field> -->
                <vuetify-money
                  v-model="qtyProduct"
                  :error-messages="errorQtyProduct"
                  class=""
                  outlined
                  label="Quantidade"
                />
              </v-col>
              <v-col class="text-center">
                <v-btn
                  fab
                  color="secondary"
                  class="mr-2 ml-2"
                  @click="minusQtyProduct()"
                >
                  <v-icon>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <v-btn
                  fab
                  color="primary"
                  @click="addQtyProduct()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="col-8">
                <SelectPdv
                  v-model="pdv"
                  :errors="errorPdv"
                  @change="errorPdv = null"
                ></SelectPdv>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogQty = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingAddProduct"
                  :disabled="(loadingAddProduct && btnAddQtyProduct)"
                  x-large
                  @click="addProduct()"
                >
                  Adicionar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- REMOVER PRODUCT -->
      <v-dialog
        v-model="dialogRemoveQty"
        width="500"
      >
        <v-card>
          <BarTitleDialog
            title="quantidade"
            @close="dialogRemoveQty = false"
          />
          <v-card-text>
            <v-row
              no-gutters
              class="mb-8"
            >
              <v-col>
                <h3>Quantidade: {{ formatMoney(qtyCurrentProduct) }}</h3>
              </v-col>
            </v-row>

            <v-row
              no-gutters
              style="height:90px"
            >
              <v-col cols="8">
                <vuetify-money
                  v-model="qtyRemoveProduct"
                  :error-messages="errorQtyRemoveProduct"
                  class=""
                  outlined
                  label="Quantidade Retirada"
                />
              </v-col>
              <v-col class="text-center">
                <v-btn
                  fab
                  color="secondary"
                  class="mr-2 ml-2"
                  @click="minusQtyRemoveProduct()"
                >
                  <v-icon>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <v-btn
                  fab
                  color="primary"
                  @click="addQtyRemoveProduct()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="obsRemoveProduct"
                  :error-messages="errorObsRemoveProduct"
                  rows="2"
                  outlined
                  label="Observação"
                  required
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogRemoveQty = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="error"
                  :loading="loadingRemovedProduct"
                  :disabled="btnQtyRemoveProduct"
                  x-large
                  @click="removeProduct()"
                >
                  remover
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG ADICIONAR SERVIÇO -->
      <v-dialog
        v-model="dialogQtyService"
        width="500"
      >
        <v-card>
          <BarTitleDialog
            title="quantidade"
            @close="dialogQtyService = false"
          />
          <v-card-text>
            <v-row
              no-gutters
              style="height:90px"
            >
              <v-col cols="8">
                <vuetify-money
                  v-model="qtyService"
                  :error-messages="errorQtyService"
                  class=""
                  outlined
                  label="Quantidade"
                />
              </v-col>
              <v-col class="text-center">
                <v-btn
                  fab
                  color="secondary"
                  class="mr-2 ml-2"
                  @click="minusQtyService()"
                >
                  <v-icon>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <v-btn
                  fab
                  color="primary"
                  @click="addQtyService()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogQtyService = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :disabled="btnAddQtyProduct"
                  x-large
                  @click="addService()"
                >
                  Adicionar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG REMOVE SERVIÇO -->
      <v-dialog
        v-model="dialogRemoveQtyService"
        width="500"
      >
        <v-card>
          <BarTitleDialog
            title="quantidade"
            @close="dialogRemoveQtyService = false"
          />
          <v-card-text>
            <v-row
              no-gutters
              class="mb-8"
            >
              <v-col>
                <h3>Quantidade: {{ formatMoney(qtyCurrentService) }}</h3>
              </v-col>
            </v-row>

            <v-row
              no-gutters
              style="height:90px"
            >
              <v-col cols="8">
                <vuetify-money
                  v-model="qtyRemoveService"
                  :error-messages="errorQtyRemoveService"
                  class=""
                  outlined
                  label="Quantidade Retirada"
                />
              </v-col>
              <v-col class="text-center">
                <v-btn
                  fab
                  color="secondary"
                  class="mr-2 ml-2"
                  @click="minusQtyRemoveService()"
                >
                  <v-icon>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <v-btn
                  fab
                  color="primary"
                  @click="addQtyRemoveService()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="obsRemoveService"
                  :error-messages="errorObsRemoveService"
                  rows="2"
                  outlined
                  label="Observação"
                  required
                  @input="errorObsRemoveService = null"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogRemoveQtyService = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="error"
                  :loading="loadingRemovedService"
                  :disabled="btnQtyRemoveService"
                  x-large
                  @click="removeService()"
                >
                  remover
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG TRANSFERENCIA DE QUARTO -->
      <v-dialog
        v-model="dialogTranfRoom"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Transferir Quarto"
            @close="dialogTranfRoom = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row>
              <v-col>
                <SelectRoom
                  v-model="roomId"
                  :errors="errorRoomTransf"
                  @change="errorRoomTransf = null"
                ></SelectRoom>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="transfJustification"
                  :error-messages="errorTransfJustification"
                  outlined
                  rows="2"
                  label="Justificativa"
                  @input="errorTransfJustification = null"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogTranfRoom = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendTransfRoom()"
                >
                  Transferir
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG TRANSFERENCIA DE ITENS -->
      <v-dialog
        v-model="dialogTranfItens"
        width="800"
      >
        <v-card>
          <BarTitleDialog
            title="Transferir Itens"
            @close="dialogTranfItens = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row
              class="mr-4"
              no-gutters
              align="center"
            >
              <v-col>
                <h4><b>Selecione os Itens:</b></h4>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  small
                  outlined
                  color="primary"
                  @click="toggleSelectAll"
                >
                  <v-icon
                    small
                    left
                  >
                    {{ allItemsSelected ? icons.mdiCheckboxMarked : icons.mdiCheckboxBlankOutline }}
                  </v-icon>
                  {{ allItemsSelected ? 'Desmarcar Todos' : 'Marcar Todos' }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-card
                  outlined
                  class="mt-2"
                  style="max-height: 300px; overflow-y: auto;"
                >
                  <v-list
                    v-if="transItens.length > 0"
                    dense
                  >
                    <v-list-item
                      v-for="item in transItens"
                      :key="item.id"
                      class="px-2"
                    >
                      <v-list-item-action class="mr-2">
                        <v-checkbox
                          v-model="item.checked"
                          color="primary"
                          hide-details
                          @change="addItemToSend(item)"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          <b style="color:#16b1ff;">{{ item.description }}</b>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="flex-row align-center">
                        <span class="mr-2">{{ item.pivot.quantity }}x</span>
                        <span class="font-weight-bold">R$ {{ formatMoney(item.sale_price) }}</span>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-card-text
                    v-else
                    class="text-center grey--text"
                  >
                    Nenhum item disponível para transferir
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <SelectRoomOccupied
                  v-model="roomId"
                  :errors="errorRoomTransf"
                  @change="errorRoomTransf = null"
                >
                </SelectRoomOccupied>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="transfJustification"
                  :error-messages="errorTransfJustification"
                  outlined
                  rows="2"
                  label="Justificativa"
                  @input="errorTransfJustification = null"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogTranfRoom = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  class="mr-4 white--text"
                  color="orange"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendTransItensOutstanding()"
                >
                  Transferir p/ Avulsa
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendTransItens()"
                >
                  Transferir
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG TRANSFERENCIA DE DIÁRIAS -->
      <v-dialog
        v-model="dialogTranfDiarias"
        width="800"
      >
        <v-card>
          <BarTitleDialog
            title="Transferir Diárias"
            @close="dialogTranfDiarias = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row
              class="mr-4"
              no-gutters
              align="center"
            >
              <v-col>
                <h4><b>Selecione as Diárias:</b></h4>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  small
                  outlined
                  color="primary"
                  @click="toggleSelectAllDiarias"
                >
                  <v-icon
                    small
                    left
                  >
                    {{ allDiariasSelected ? icons.mdiCheckboxMarked : icons.mdiCheckboxBlankOutline }}
                  </v-icon>
                  {{ allDiariasSelected ? 'Desmarcar Todas' : 'Marcar Todas' }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-card
                  outlined
                  class="mt-2"
                  style="max-height: 300px; overflow-y: auto;"
                >
                  <v-list
                    v-if="transDiarias.length > 0"
                    dense
                  >
                    <v-list-item
                      v-for="item in transDiarias"
                      :key="item.id"
                      class="px-2"
                    >
                      <v-list-item-action class="mr-2">
                        <v-checkbox
                          v-model="item.checked"
                          color="primary"
                          hide-details
                          @change="addDiariaToSend(item)"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          <b style="color:#16b1ff;">{{ formatDate(item.date_start) }} - {{ formatDate(item.date_end) }}</b>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="flex-row align-center">
                        <span class="font-weight-bold">R$ {{ formatMoney(item.value) }}</span>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-card-text
                    v-else
                    class="text-center grey--text"
                  >
                    Nenhuma diária disponível para transferir
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <SelectRoomOccupied
                  v-model="roomId"
                  :errors="errorRoomTransf"
                  @change="errorRoomTransf = null"
                >
                </SelectRoomOccupied>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="transfJustification"
                  :error-messages="errorTransfJustification"
                  outlined
                  rows="2"
                  label="Justificativa"
                  @input="errorTransfJustification = null"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogTranfDiarias = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  class="mr-4 white--text"
                  color="orange"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendTransDiariasOutstanding()"
                >
                  Transferir p/ Avulsa
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendTransDiarias()"
                >
                  Transferir
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG EDITAR CHECKOUT e CHECKOUT -->
      <v-dialog
        v-model="dialogEditCheckout"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Editar Checkout"
            @close="dialogEditCheckout = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row
              v-for="item in accommodationItems"
              :key="index"
              no-gutters
              class="mb-2"
            >
              <v-col>
                <vuetify-money
                  v-model="item.value"
                  :option="{ prefix: 'R$' }"
                  dense
                  outlined
                  hide-details
                  :disabled="item.hotel_day_id != null"
                ></vuetify-money>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="item.date_start"
                  hide-details=""
                  type="datetime-local"
                  :readonly="IfOneItem || item.hotel_day_id != null"
                  class="ml-2"
                  outlined
                  dense
                  label="Data Inicio"
                  :disabled="item.hotel_day_id != null"
                  @blur="changeAccomodation()"
                ></v-text-field>
                <!-- <input-date css="ml-2" v-model="tariff.date_start" :label="'Data Inicial'" :dense="true"></input-date> -->
              </v-col>
              <v-col>
                <v-text-field
                  hide-details=""
                  type="datetime-local"
                  readonly
                  class="ml-2"
                  outlined
                  dense
                  :value="item.date_end"
                  label="Data Fim"
                  :disabled="item.hotel_day_id != null"
                ></v-text-field>
                <!-- <input-date css="ml-2" v-model="tariff.date_end" :label="'Data Final'" :dense="true"></input-date> -->
              </v-col>
              <!-- <v-col cols="1"> -->
              <!-- <v-btn icon color="error" class="ml-2" @click="removeTariffExtraordinary(tariff)" >
                                <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                            </v-btn> -->
              <!-- </v-col> -->
            </v-row>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  color="primary"
                  class="ml-2"
                  @click="addAccommodationItem()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar Diária
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  color="error"
                  class="ml-2"
                  @click="removeAccommodationItem()"
                >
                  <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>Remover Diária
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
              hide-default-footer
              :headers="headers_observation"
              :items="accommodation_observations"
              class="elevation-1"
              dense
              hide-default-header
            >
              <template v-slot:no-data>
                <NoDataTable></NoDataTable>
              </template>
              <template v-slot:top>
                <v-toolbar
                  flat
                  dense
                >
                  <v-toolbar-title>Observações:</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-btn
                    icon
                    large
                    color="primary"
                    @click="showDialogObsCheckout(item)"
                  >
                    <v-icon>{{ icons.mdiPlus }}</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn
                  icon
                  large
                  color="error"
                  @click="removeObservations(item)"
                >
                  <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogEditCheckout = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingEditCheckout"
                  :disabled="loadingEditCheckout"
                  x-large
                  @click="saveEditCheckout()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG CONSUMO HOSPEDE -->
      <!--DIALOG DETALHES DO QUARTO  -->
      <v-dialog
        v-model="dialogConsumption"
        width="800"
      >
        <v-card>
          <BarTitleDialog
            :title="'Consumo do quarto - ' + roomDescription"
            @close="dialogConsumption = false"
          >
          </BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <h3>Hospedagem:</h3>
                <v-row no-gutters>
                  <v-col cols="7">
                    <b>DESCRIÇÃO</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>QTD.</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>P.UNIT</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>SUB. TOTAL</b>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row
                  v-for="(accommodation, index) in room.accommodationItemsCurrent"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="7">
                    HOSPEDAGEM {{ formatDate(accommodation.date_start) + '
                    - '+formatDate(accommodation.date_end)}}
                  </v-col>
                  <v-col class="text-right">
                    1,00
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(accommodation.value) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(accommodation.value) }}
                  </v-col>
                </v-row>
                <v-row
                  v-for="(accommodation, index) in room.current_accommodation.extra_items"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="7">
                    {{ accommodation.description }}
                  </v-col>
                  <v-col class="text-right">
                    1,00
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(accommodation.value) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(accommodation.value) }}
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="9">
                    <b>Total (R$):</b>
                  </v-col>
                  <v-col><b></b></v-col>
                  <v-col><b></b></v-col>
                  <v-col class="text-right">
                    <b>{{ formatMoney(totalAccommodation) }}</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h3>Produtos:</h3>
                <v-row no-gutters>
                  <v-col cols="6">
                    <b>DESCRIÇÃO</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>DATA</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>QTD.</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>P.UNIT</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>SUB. TOTAL</b>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row
                  v-for="(product, index) in postedProducts"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="6">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ product.description }}
                        </span>
                      </template>
                      <span> lancado por: {{ product.user }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col class="text-right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ formatDate(product.date) }}
                        </span>
                      </template>
                      <span>{{ formatHour(product.date) }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(product.quantity) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(product.sale_price) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(product.total) }}
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="9">
                    <b>Total (R$):</b>
                  </v-col>
                  <v-col><b></b></v-col>
                  <v-col><b></b></v-col>
                  <v-col class="text-right">
                    <b>{{ formatMoney(totalProduct) }}</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3>Serviços:</h3>
                <v-row no-gutters>
                  <v-col cols="6">
                    <b>DESCRIÇÃO</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>DATA</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>QTD.</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>P.UNIT</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>SUB. TOTAL</b>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row
                  v-for="(service, index) in postedServices"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="6">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ service.description }}
                        </span>
                      </template>
                      <span> lancado por: {{ service.user }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col class="text-right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ formatDate(service.date) }}
                        </span>
                      </template>
                      <span>{{ formatHour(service.date) }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(service.quantity) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(service.sale_price) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(service.total) }}
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="9">
                    <b>Total (R$):</b>
                  </v-col>
                  <v-col><b></b></v-col>
                  <v-col><b></b></v-col>
                  <v-col class="text-right">
                    <b>{{ formatMoney(totalService) }}</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3>Adiantamentos:</h3>
                <v-row no-gutters>
                  <v-col cols="7">
                    <b>DESCRIÇÃO</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>QTD.</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>P.UNIT</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>SUB. TOTAL</b>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row
                  v-for="(payment, index) in partialPayments"
                  key="index"
                  no-gutters
                >
                  <v-col cols="7">
                    {{ paymentDescription(payment.method) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(1) }}
                  </v-col>
                  <v-col class="text-right"></v-col>
                  <v-col class="text-right">
                    {{ formatMoney(payment.value) }}
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="9">
                    <b>Total (R$):</b>
                  </v-col>
                  <v-col><b></b></v-col>
                  <v-col><b></b></v-col>
                  <v-col class="text-right">
                    <b>{{ formatMoney(totalPayment()) }}</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="text-right"
                style="font-size:16px"
              >
                Impostos (R$): <div
                  style="float:right;width:90px"
                >
                  {{ formatMoney(room.tax) }}
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col
                cols="12"
                class="text-right"
                style="color:black;font-size:16px"
              >
                <b> Total (R$): <div
                  style="float:right;width:90px"
                >{{ formatMoney(totalAmount) }}</div></b>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  class="mr-2"
                  color="warning"
                  :loading="loadingPrintDetails"
                  :disabled="loadingPrintDetails"
                  x-large
                  @click="printDetails()"
                >
                  <v-icon>
                    {{ icons.mdiPrinter
                    }}
                  </v-icon>&nbsp Imprimir Conta
                </v-btn>
                <v-btn
                  class="mr-2"
                  color="secondary"
                  :loading="loadingPrintAcommodation"
                  :disabled="loadingPrintAcommodation"
                  x-large
                  @click="printAccommodation()"
                >
                  <v-icon>
                    {{ icons.mdiPrinter
                    }}
                  </v-icon>&nbsp Imprimir Hospedagem
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingPrintConsumption"
                  :disabled="loadingPrintConsumption"
                  x-large
                  @click="printConsumption()"
                >
                  <v-icon>{{ icons.mdiPrinter }}</v-icon>&nbsp Imprimir Consumo
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG OBSERVAÇÃO -->
      <v-dialog
        v-model="dialogObs"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Observações"
            @close="dialogObs = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="roomObs"
                  :error-messages="errorTransfJustification"
                  outlined
                  rows="3"
                  label="Observação"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogObs = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="saveObs()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG OBSERVAÇÃO -->
      <v-dialog
        v-model="dialogObsCheckout"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Observações"
            @close="dialogObsCheckout = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="onservation_input"
                  :error-messages="errorTransfJustification"
                  outlined
                  rows="2"
                  label="Observação"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogObsCheckout = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="addObservation()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG Alterar Placa -->
      <v-dialog
        v-model="dialogChangeLicensePlate"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Alterar Placa Veículo"
            @close="dialogChangeLicensePlate = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="licensePlate"
                  label="Placa do veículo"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogChangeLicensePlate = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  x-large
                  @click="saveLicensePlate()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG  AUTHORIZATION  -->
      <v-dialog
        v-model="dialogAuthorization"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Autorizar"
            @close="cancelAuthorization"
          />
          <v-card-text>
            <v-row class="mt-3">
              <v-col>
                <v-text-field
                  v-model="admLogin.email"
                  outlined
                  label="Email"
                  placeholder="Digite seu email"
                  hide-details="auto"
                  class="mb-6 mt-2"
                  :error-messages="message_error_email"
                  @keyup="validEmail"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="admLogin.password"
                  outlined
                  label="Senha"
                  type="password"
                  placeholder="Digite sua senha"
                  hide-details="auto"
                  :error-messages="message_error_email"
                  @keyup="validPassword"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  class="mr-2"
                  x-large
                  :disabled="authorizationProcessing"
                  @click="cancelAuthorization()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  x-large
                  :loading="authorizationProcessing"
                  :disabled="authorizationProcessing"
                  @click="requestAuthorization()"
                >
                  Autorizar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIALOG Exta Diaria -->
      <v-dialog
        v-model="dialogExtra"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Tarifas Extraordinárias"
            @close="closeExtraDialog"
          ></BarTitleDialog>
          <v-card-text>
            <v-row
              v-for="item in accommodation_exta"
              :key="index"
              no-gutters
              class="mb-2"
            >
              <v-col cols="3">
                <vuetify-money
                  v-model="item.value"
                  :option="{ prefix: 'R$' }"
                  dense
                  outlined
                  hide-details
                  :disabled="item.hotel_day_id != null"
                ></vuetify-money>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="item.description"
                  hide-details=""
                  class="ml-2"
                  outlined
                  dense
                  label="Descrição"
                  :disabled="item.hotel_day_id != null"
                  @blur=""
                ></v-text-field>
              </v-col>
              <v-col
                v-if="item.hotel_day_id != null"
                cols="1"
                class="d-flex align-center justify-center"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="warning"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ icons.mdiLock }}
                    </v-icon>
                  </template>
                  <span>Item auditado - Não pode ser editado</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  color="primary"
                  class="ml-2"
                  @click="addExtraItem()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar Tarifa
                </v-btn>
              </v-col>
              <v-col class="text-center">
                <v-btn
                  color="error"
                  class="ml-2"
                  @click="addExtraItemDiscount()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar Desconto
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="closeExtraDialog"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingEditCheckout"
                  :disabled="loadingEditCheckout"
                  x-large
                  @click="updateExtraTariff()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG Avulsa -->
      <v-dialog
        v-model="dialogOutstanding"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Migrar para conta avulsa?"
            @close="dialogOutstanding = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row>
              <v-col>
                <span class="text-body-1">Confirma migrar para conta avulsa?</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="outstandingJustification"
                  :error-messages="errorOutstandingJustification"
                  outlined
                  rows="2"
                  label="Motivo"
                  @input="errorOutstandingJustification = null"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  x-large
                  color="error"
                  class="mr-4"
                  @click="dialogOutstanding = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="moveOutstanding()"
                >
                  Confirmar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Cancelar Checkin -->
      <v-dialog
        v-model="dialogCancel"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Cancelar CheckIn"
            @close="dialogCancel = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="cancelInput"
                  :error-messages="errorCancelInput"
                  outlined
                  rows="2"
                  label="Justificativa"
                  @input="errorCancelInput = null"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogCancel = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendCancelChekin()"
                >
                  Confirmar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogPrintCommands"
        max-width="900px"
      >
        <v-card>
          <v-card-title class="d-flex align-center">
            Histórico de comandas
            <v-spacer />
            <v-btn
              icon
              @click="dialogPrintCommands = false"
            >
              <v-icon>{{ icons.mdiClose }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>
            Cada registro preserva os itens e quantidades enviados juntos.
          </v-card-subtitle>
          <v-card-text>
            <v-progress-linear
              v-if="loadingPrintCommands"
              indeterminate
              color="primary"
            />
            <v-alert
              v-else-if="!printCommands.length"
              type="info"
              text
            >
              Nenhuma comanda foi criada para esta acomodação.
            </v-alert>
            <v-expansion-panels
              v-else
              accordion
            >
              <v-expansion-panel
                v-for="command in printCommands"
                :key="command.id"
              >
                <v-expansion-panel-header>
                  <div class="d-flex align-center flex-grow-1">
                    <strong>Comanda #{{ command.id }}</strong>
                    <span class="ml-3 text--secondary">{{ formatPrintCommandDate(command.created_at) }}</span>
                    <v-spacer />
                    <v-chip
                      small
                      :color="printCommandColor(command)"
                      dark
                      class="mr-3"
                    >
                      {{ printCommandStatus(command) }}
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table dense>
                    <thead>
                      <tr>
                        <th>Produto</th><th class="text-right">
                          Qtd.
                        </th><th class="text-right">
                          Valor
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in command.items"
                        :key="item.id"
                      >
                        <td>{{ item.product_code }} - {{ item.description }}</td>
                        <td class="text-right">
                          {{ Number(item.quantity) }}
                        </td>
                        <td class="text-right">
                          {{ formatMoney(item.unit_price) }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <div class="d-flex justify-end mt-4">
                    <v-btn
                      color="secondary"
                      :loading="reprintingCommandId === command.id"
                      @click="sendReprintCommand(command)"
                    >
                      <v-icon left>
                        {{ icons.mdiPrinter }}
                      </v-icon>
                      Reimprimir comanda
                    </v-btn>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
  </div>
</template>

<script>
import {
  mdiDeleteOutline, mdiPlus, mdiMinus, mdiMenu, mdiLock, mdiCheckboxMarked, mdiCheckboxBlankOutline, mdiPrinter, mdiHistory, mdiClose,
} from '@mdi/js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AutocompleteSearchProduct from '@/components/AutocompleteSearchProduct.vue'
import AutocompleteSearchService from '@/components/AutocompleteSearchService.vue'
import TableGuestBusy from './TableGuestBusy.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import SelectRoom from '@/components/SelectRoom.vue'
import SelectRoomOccupied from '@/components/SelectRoomOccupied.vue'
import SelectPdv from '@/components/SelectPdv.vue'

export default {
  components: {
    BarTitleDialog,
    AutocompleteSearchProduct,
    SelectRoom,
    AutocompleteSearchService,
    SelectPdv,
    TableGuestBusy,
    SelectRoomOccupied,

  },
  props: {
    room: {
      type: Object,
    },
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    // DIALOG CONSUMPTION
    dialogConsumption: false,
    loadingPrintConsumption: false,
    loadingPrintAcommodation: false,
    loadingPrintDetails: false,
    roomDescription: '',
    partialPayments: [],

    // DIALOG CANCELAR
    dialogCancel: false,
    errorCancelInput: null,
    cancelInput: '',

    loading: false,

    // Admin Status
    admRole: {},
    dialogAuthorization: false,
    message_error_email: '',
    message_error_password: '',
    admLogin: {
      email: '',
      password: '',
    },
    authorizationProcessing: false,

    // Contexto original para autorização
    originalContext: {
      user_id: null,
      cash_id: null,
    },

    // Extra Diaria
    dialogExtra: false,
    accommodation_exta: [],

    // Avulsa
    dialogOutstanding: false,
    outstandingJustification: '',
    errorOutstandingJustification: null,

    // Observações
    accommodation_observations: [],
    onservation_input: '',
    headers_observation: [
      {
        text: 'Observações',
        sortable: false,
        align: 'start',
        value: 'description',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],
    loadingAddProduct: false,
    tab: null,
    loadingTransf: false,
    roomId: null,
    transfJustification: '',
    errorTransfJustification: null,
    errorRoomTransf: null,
    dialogTranfRoom: false,
    dialogTranfItens: false,
    dialogTranfDiarias: false,
    errorQtyRemoveProduct: null,
    errorObsRemoveProduct: null,
    dialogRoom: false,
    descriptionRoom: '',
    editedItemLoading: false,

    // PAGAMNETO PARCIAL
    loadingPayment: false,

    // PRODUTO
    loadingRemovedProduct: false,
    obsRemoveProduct: '',
    btnQtyRemoveProduct: false,
    dialogQty: false,
    dialogRemoveQty: false,
    qtyRemoveProduct: 1,
    qtyCurrentProduct: 0,
    productRemove: {},
    products: [],
    qtyProduct: 1,
    product: null,
    errorQtyProduct: null,
    errorPdv: null,
    btnAddQtyProduct: false,
    loadingPrintProduct: false,
    hasPrinters: false,
    dialogPrintCommands: false,
    loadingPrintCommands: false,
    reprintingCommandId: null,
    printCommands: [],
    productsPrint: [],
    pdv: 1,

    // EDITAR CHECKOUT
    dialogEditCheckout: false,
    accommodationItems: [],
    accommodation_items_backup: [],
    loadingEditCheckout: false,

    // LANÇAMENTO
    postedItems: [],
    postedProducts: [],
    postedServices: [],

    // TRANSFERENCIA DE ITENS
    sendItens: [],

    // TRANSFERENCIA DE DIÁRIAS
    sendDiarias: [],

    // SERVIÇO
    services: [],
    service: null,
    dialogQtyService: false,
    qtyService: 1,
    errorQtyService: null,
    dialogRemoveQtyService: false,
    qtyRemoveService: 1,
    errorQtyRemoveService: null,
    qtyCurrentService: 0,
    obsRemoveService: '',
    errorObsRemoveService: null,
    loadingRemovedService: false,
    btnQtyRemoveService: false,
    serviceRemove: {},
    pendingAuthorization: null,

    // DIALOG Observação
    dialogObs: false,
    roomObs: '',

    // DIALOG Authorization
    dialogAuthorization: false,

    // DIALOG Alterar Placa
    dialogChangeLicensePlate: false,
    licensePlate: '',

    dialogObsCheckout: false,

    // HOSPEDE
    guests: [],
    headers_guests: [
      {
        text: 'NOME',
        align: 'start',
        value: 'name',
      },
      {
        text: 'TELEFONE',
        value: 'cell_phone',
      },
      {
        text: 'EMAIL',
        value: 'email',
      },
    ],

    headers: [
      {
        text: 'PRODUTO',
        align: 'start',
        value: 'description',
      },
      {
        text: 'Ponto de Venda',
        align: 'center',
        value: 'pdv',
      },
      {
        text: 'QTDE',
        align: 'center',
        value: 'qty',
      },
      {
        text: 'P. UND. (R$)',
        align: 'right',
        value: 'sale_price',
      },
      {
        text: 'TOTAL',
        align: 'right',
        value: 'total',
      },
      {
        text: '',
        align: 'center',
        value: 'print',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],
    headers_service: [
      {
        text: 'PRODUTO',
        align: 'start',
        value: 'description',
      },

      {
        text: 'QTDE',
        align: 'center',
        value: 'qty',
      },
      {
        text: 'P. UND. (R$)',
        align: 'right',
        value: 'sale_price',
      },
      {
        text: 'TOTAL',
        align: 'right',
        value: 'total',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],
    statusItems: [
      {
        value: 'sujo',
        text: 'Sujo',
      },
      {
        value: 'bloqueado',
        text: 'Bloqueado',
      },
      {
        value: 'diaria',
        text: 'Diaria',
      },
      {
        value: 'disponivel',
        text: 'Disponível',
      },
      {
        value: 'conferencia',
        text: 'Conferência',
      },
      {
        value: 'encerramento',
        text: 'Encerramento',
      },
      {
        value: 'limpeza',
        text: 'Limpeza',
      },
      {
        value: 'manutencao',
        text: 'Manutenção',
      },
      {
        value: 'ocupado',
        text: 'Ocupado',
      },
      {
        value: 'periodo',
        text: 'Período',
      },
      {
        value: 'pernoite',
        text: 'Pernoite',
      },
      {
        value: 'reservado',
        text: 'Reservado',
      },
      {
        value: 'stand-by',
        text: 'Stand-by',
      },
    ],
    rooms: [],
    editedItem: {},
    indexItem: null,
    icons: {
      mdiDeleteOutline,
      mdiPlus,
      mdiMinus,
      mdiMenu,
      mdiLock,
      mdiCheckboxMarked,
      mdiCheckboxBlankOutline,
      mdiPrinter,
      mdiHistory,
      mdiClose,
    },
    hasPrinters: false,
    currentSessionAccommodationId: null,
  }),
  watch: {
    value(val) {
      if (val) {
        this.hydrateFromRoom(this.room, true)
        this.loadObservations(this.room.current_accommodation.id)
        this.loadRooms('disponivel') // carrega todos os quartos disponivel da tela de transferir quarto
        this.consumptionAlert()
      }
      if (!val) {
        this.resetTransientState()
      }
    },
    qtyProduct() {
      if (this.qtyProduct > 0) {
        this.errorQtyProduct = null
        this.btnAddQtyProduct = false
      } else {
        this.errorQtyProduct = 'Quantidade deve ser maior que zero'
        this.btnAddQtyProduct = true
      }
    },
    qtyRemoveProduct() {
      if (this.qtyRemoveProduct <= this.qtyCurrentProduct) {
        this.errorQtyRemoveProduct = null
        this.btnQtyRemoveProduct = false
      } else {
        this.errorQtyRemoveProduct = 'Quantidade retirada dever ser menor ou igual a quantidade atual'
        this.btnQtyRemoveProduct = true
      }
    },
    room(val) {
      if (val) {
        this.hydrateFromRoom(val, true)
        this.loadPartialPayment()
      }
    },

    // products(val){
    //   this.$emit('input', val)
    // }
  },

  created() {
    if (this.value) {
      this.hydrateFromRoom(this.room, true)
      this.loadRooms('disponivel')
      this.loadObservations(this.room.current_accommodation.id)
      this.loadCurrentRole()
      this.captureOriginalContext()
      this.verifyReserveStatus()
      this.loadPartialPayment()
    }
    this.loadPdvs()
    this.inicialize()
    this.checkPrinters()
  },
  computed: {
    ...mapGetters('checkout', ['getSubtotal', 'getTotalToPay', 'getTaxation']),
    ...mapGetters('select', ['getPdvs']),
    ...mapGetters('config', {
      issRate: 'getIssRate',
    }),
    calcTotalProductAmount() {
      const result = this.products.reduce((acc, product) => acc + this.calcTotalProduct(product), 0)

      return result
    },
    calcTotalServiceAmount() {
      const result = this.services.reduce((acc, service) => acc + this.calcTotalService(service), 0)

      return result
    },

    calcTotalAccommodation() {
      return this.calcTotalProductAmount + this.room.current_accommodation.accommodation_value
    },
    itemsProducts() {
      // let products_agruped = []
      // this.products.forEach(item => {
      //   let product = products_agruped.find(product => {
      //     return product.id == item.id
      //   })
      //   if (product) {
      //     // se exitir mais de item do mesmo produto soma só a quantidade
      //     product.pivot.quantity += item.pivot.quantity
      //   } else {
      //     products_agruped.push(Object.assign({}, item))
      //   }
      // })
      // return products_agruped
      return this.products.map((item, index) => ({
        ...item,
        __rowKey: `product-${item.id}-${item?.pivot?.pdv_id || 'no-pdv'}-${index}`,
      }))
    },
    itemsServices() {
      return this.services.map((item, index) => ({
        ...item,
        __rowKey: `service-${item.id}-${index}`,
      }))
    },
    transItens() {
      const transItens = []
      this.products.forEach(item => {
        transItens.push({ ...item, origin: 'product' })
      })
      this.services.forEach(item => {
        transItens.push({ ...item, origin: 'service' })
      })

      return transItens
    },
    totalProduct() {
      return this.room.current_accommodation.product.reduce((acc, product) => acc + parseFloat(product.pivot.quantity) * parseFloat(product.sale_price), 0)
    },
    totalService() {
      return this.room.current_accommodation.service.reduce((acc, service) => acc + parseFloat(service.pivot.quantity) * parseFloat(service.sale_price), 0)
    },
    totalAccommodation() {
      const accommodation_items_value = this.room.accommodationItemsCurrent.reduce((acc, accomodation) => acc + parseFloat(accomodation.value), 0)
      const accommodation_exta_value = this.room.current_accommodation.extra_items.reduce((acc, accomodation) => acc + parseFloat(accomodation.value), 0)

      return accommodation_items_value + accommodation_exta_value
    },
    totalAmount() {
      return (
        parseFloat(this.totalProduct)
        + parseFloat(this.totalService)
        + parseFloat(this.totalAccommodation)
        + parseFloat(this.room.tax)
        - parseFloat(this.totalPayment())

      )
    },
    IfOneItem() {
      if (this.accommodationItems.length == 1) {
        return false
      }

      return true
    },
    hasAuditedTariffs() {
      // Verifica se alguma tarifa já foi auditada (tem hotel_day_id)
      return this.accommodationItems.some(item => item.hotel_day_id)
    },
    allItemsSelected() {
      // Verifica se todos os itens estão marcados
      return this.transItens.length > 0 && this.transItens.every(item => item.checked)
    },
    transDiarias() {
      // Apenas diárias não auditadas podem ser transferidas
      return (this.room.current_accommodation.accommodation_item || []).filter(item => !item.hotel_day_id)
    },
    allDiariasSelected() {
      return this.transDiarias.length > 0 && this.transDiarias.every(item => item.checked)
    },
  },
  methods: {
    ...mapActions('outstanding', ['storeOutstanding']),
    ...mapActions('open_account', ['exportDetailsPdf']),
    ...mapActions('select', ['loadRooms', 'loadPdvs']),
    ...mapActions('manager_room', ['getAllRoom']),
    ...mapActions('printers', { listPrinters: 'listPrinters' }),
    ...mapActions('busy', [
      'updateRoomBusy',
      'storeItemRemoved',
      'storeTransfRoom',
      'printProduct',
      'listPrintCommands',
      'reprintCommand',
      'updateEditCheckout',
      'exportAccommodationPdf',
      'exportConsumptionPdf',
      'updateObservations',
      'getAccommodationObservations',
      'alertConsumptionLimit',
      'updateExtraTarrif',
      'cancelCheckin',
      'updateReserve',
      'storeTransItens',
      'storeTransItensOutstanding',
      'storeTransDiarias',
      'storeTransDiariasOutstanding',
    ]),
    ...mapMutations('checkout', [
      'setRoom',
      'setCheckout',
      'setStage',
      'clearCheckoutSeparete',
      'setOriginPartialPayment',
    ]),
    ...mapActions('checkout', [
      'getUser',
      'getPartialPayment',
    ]),
    ...mapActions('cash', ['getCash']),
    ...mapActions('authorization', { runAuthorization: 'run' }),

    // modficar data primeiro data em editar checkout
    changeAccomodation() {
      const next_date = new Date(this.accommodationItems[0].date_start)
      next_date.setDate(next_date.getDate() + 1)
      const next_date1 = `${next_date.toISOString().substring(0, 10)} 14:00:00`

      this.accommodationItems[0].date_end = next_date1
    },

    // imprimir
    printConsumption() {
      this.loadingPrintConsumption = true
      this.exportConsumptionPdf(this.room)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'export.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {

        })
        .finally(() => {
          this.loadingPrintConsumption = false
        })
    },
    printAccommodation() {
      this.loadingPrintAcommodation = true
      this.exportAccommodationPdf(this.room)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'export.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {

        })
        .finally(() => {
          this.loadingPrintAcommodation = false
        })
    },
    printDetails() {
      this.loadingPrintDetails = true
      this.exportDetailsPdf(this.room)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'export.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {

        })
        .finally(() => {
          this.loadingPrintDetails = false
        })
    },

    // Add Guest
    updateGuest() {
      this.save().catch(() => {})
    },

    // DIALOG DE EDITAR CHECKOUT
    showEditCheckout() {
      this.dialogEditCheckout = true
      const source = this.room.current_accommodation.accommodation_item || []
      this.accommodationItems = this.cloneAccommodationItems(source)
      this.accommodation_items_backup = this.cloneAccommodationItems(source)
      this.ensureAllAccommodationItemsAreVisible()
    },

    // dialogConsumption
    showDialogConsumption() {
      this.dialogConsumption = true
    },

    showDialogObs() {
      this.dialogObs = true
    },
    showdialogChangeLicensePlate() {
      this.dialogChangeLicensePlate = true
    },

    addAccommodationItem() {
      const lastItem = this.accommodationItems[this.accommodationItems.length - 1]
      const date_end = new Date(lastItem.date_end)
      const date_end1 = `${date_end.toISOString().substring(0, 10)} 14:00:00`
      const next_date = new Date(date_end1)
      next_date.setDate(date_end.getDate() + 1)
      const next_date1 = `${next_date.toISOString().substring(0, 10)} 14:00:00`

      // Usa o valor da última tarifa ao invés de 0
      const lastValue = Number(lastItem.value) || 0

      this.accommodationItems.push({ value: lastValue, date_start: date_end1, date_end: next_date1 })
    },
    removeAccommodationItem() {
      // Verifica se há apenas uma tarifa
      if (this.accommodationItems.length <= 1) {
        this.$toast.error('Não é permitido remover todas as tarifas. Deve haver pelo menos uma diária.')

        return
      }

      // Verifica se a última tarifa está auditada
      const lastItem = this.accommodationItems[this.accommodationItems.length - 1]
      if (lastItem.hotel_day_id) {
        this.$toast.error('Não é possível remover tarifas que já foram auditadas.')

        return
      }

      // Verifica autorização
      if (this.admRole.authorization) {
        this.accommodationItems.pop()
      } else {
        this.queueAuthorization('general')
      }
    },
    saveEditCheckout() {
      const payload = {
        accommodation_id: this.room.current_accommodation.id,
        accommodation_item: this.accommodationItems,
      }

      // Tenta executar diretamente - se der 403, performUpdateAccommodationItem abrirá dialog
      this.performUpdateAccommodationItem(payload)
    },

    performUpdateAccommodationItem(payload, token = null) {
      this.loadingEditCheckout = true

      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post(`manager_room/update_accommodation_item/${payload.accommodation_id}`, payload.accommodation_item, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.updateEditCheckout(payload)
      }

      return request
        .then(response => {
          this.$toast.success('Diárias atualizadas com sucesso')
          this.dialogEditCheckout = false
          this.room.accommodationItemsCurrent = response.data.accommodationItemsCurrent
          this.room.totalRoomCurrent = response.data.totalRoomCurrent
          const updatedItems = response.data.accommodationItemsAll || response.data.accommodationItemsCurrent || []
          this.room.current_accommodation.accommodation_item = this.cloneAccommodationItems(updatedItems)
          this.accommodation_items_backup = this.cloneAccommodationItems(this.room.current_accommodation.accommodation_item)
          this.storeCheckout()
        })
        .catch(error => {
          // CHAVE: Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('update_accommodation_item', payload)

            return Promise.resolve() // Não mostra erro, abre dialog
          }

          // Erro 422 - validação de negócio (tarifa auditada, etc)
          if (error.response?.status === 422 && error.response?.data?.error) {
            this.$toast.error(error.response.data.error)
            if (error.response.data.message) {
              this.$toast.warning(error.response.data.message)
            }
          } else {
            this.$toast.error('Erro ao atualizar tarifas')
          }
          this.restoreAccommodationItems()

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingEditCheckout = false
          this.loadCurrentRole()
        })
    },
    cloneAccommodationItems(items) {
      return items ? JSON.parse(JSON.stringify(items)) : []
    },
    restoreAccommodationItems() {
      this.accommodationItems = this.cloneAccommodationItems(this.accommodation_items_backup)
    },
    ensureAllAccommodationItemsAreVisible() {
      if (this.room && this.room.current_accommodation) {
        const fullItems = this.room.current_accommodation.accommodation_item || []
        const currentIds = this.accommodationItems.map(item => item.id)
        const missing = fullItems.filter(item => !currentIds.includes(item.id))
        if (missing.length > 0) {
          const cloned = this.cloneAccommodationItems(fullItems)
          this.accommodationItems = cloned
          this.accommodation_items_backup = this.cloneAccommodationItems(cloned)
        }
      }
    },

    sendPrintProduct() {
      this.loadingPrintProduct = true
      const printerKeys = this.getPrinterKeys()

      if (!printerKeys.length) {
        this.$toast.error('Selecione ao menos uma impressora ao abrir o caixa')
        this.loadingPrintProduct = false

        return
      }

      const data = {
        accommodation_id: this.room.current_accommodation_id,
        printer_keys: printerKeys,
      }

      this.printProduct(data)
        .then(() => {
          this.$toast.success('Pedido enviado para impressão')
        })
        .catch(() => {})
        .finally(() => {
          this.loadingPrintProduct = false
        })
    },
    showPrintCommands() {
      this.dialogPrintCommands = true
      this.loadingPrintCommands = true
      this.listPrintCommands(this.room.current_accommodation_id)
        .then(response => {
          this.printCommands = response.data || []
        })
        .catch(() => {
          this.printCommands = []
        })
        .finally(() => {
          this.loadingPrintCommands = false
        })
    },
    sendReprintCommand(command) {
      const printerKeys = this.getPrinterKeys()
      if (!printerKeys.length) {
        this.$toast.error('Selecione ao menos uma impressora ao abrir o caixa')

        return
      }

      this.reprintingCommandId = command.id
      this.reprintCommand({ commandId: command.id, printerKeys })
        .then(response => {
          const updated = response.data.command
          const index = this.printCommands.findIndex(item => item.id === updated.id)
          if (index >= 0) this.$set(this.printCommands, index, updated)
          this.$toast.success('Comanda reenviada para impressão')
        })
        .catch(() => {})
        .finally(() => {
          this.reprintingCommandId = null
        })
    },
    printCommandStatus(command) {
      const jobs = command.jobs || []
      const latestDate = jobs.reduce((latest, job) => (job.created_at > latest ? job.created_at : latest), '')
      const latestJobs = jobs.filter(job => job.created_at === latestDate)
      if (latestJobs.some(job => job.status === 'printing')) return 'Imprimindo'
      if (latestJobs.some(job => job.status === 'queued')) return 'Na fila'
      if (latestJobs.length && latestJobs.every(job => job.status === 'printed')) return 'Impresso'
      if (latestJobs.some(job => job.status === 'failed')) return 'Falha'

      return 'Criada'
    },
    printCommandColor(command) {
      const status = this.printCommandStatus(command)
      if (status === 'Impresso') return 'success'
      if (status === 'Falha') return 'error'
      if (status === 'Na fila') return 'warning'

      return 'primary'
    },
    formatPrintCommandDate(value) {
      return value ? new Date(value).toLocaleString('pt-BR') : '-'
    },
    reprintProduct(item) {
      this.loadingPrintProduct = true
      const printerKeys = this.getPrinterKeys()

      if (!printerKeys.length) {
        this.$toast.error('Selecione ao menos uma impressora ao abrir o caixa')
        this.loadingPrintProduct = false

        return
      }

      const data = {
        accommodation_id: this.room.current_accommodation_id,
        printer_keys: printerKeys,
        product_id: item.id,
        pdv_id: item?.pivot?.pdv_id,
      }

      this.printProduct(data)
        .then(() => {
          this.$toast.success('Produto reenviado para impressão')
        })
        .catch(() => {})
        .finally(() => {
          this.loadingPrintProduct = false
        })
    },
    getPrinterKeys() {
      try {
        const saved = localStorage.getItem('printerSelection')
        if (!saved) return []
        const parsed = JSON.parse(saved)
        if (Array.isArray(parsed)) {
          return parsed
            .map(item => item?.printer_key || item?.printer?.printer_key)
            .filter(key => !!key)
        }

        return parsed?.printer_key ? [parsed.printer_key] : []
      } catch (e) {
        return []
      }
    },
    async checkPrinters() {
      try {
        const response = await this.listPrinters()
        this.hasPrinters = (response.data || []).length > 0
      } catch (e) {
        this.hasPrinters = false
      }
    },
    inicialize() {
      this.getAllRoom().then(response => {
        this.rooms = response.data
      })
    },

    // TRASNFERENCIA DE QUARTO
    showTranfRoom() {
      this.dialogTranfRoom = true
      this.loadRooms('disponivel')
    },
    sendTransItens() {
      if (this.sendItens.length == 0) {
        this.$toast.error('Nenhum item selecionado')

        return false
      }
      if (this.roomId == null || this.roomId == undefined) {
        this.errorRoomTransf = 'Campo Obrigatório'

        return false
      }
      if (this.transfJustification == '') {
        this.errorTransfJustification = 'Campo Obrigatório'

        return false
      }

      const payload = {
        room_id: this.roomId,
        accommodation_id: this.room.current_accommodation.id,
        items: this.sendItens,
        justification: this.transfJustification,
      }

      // Tenta executar diretamente - se der 403, performTransferItens abrirá dialog
      this.performTransferItens(payload)
    },
    sendTransItensOutstanding() {
      if (this.sendItens.length == 0) {
        this.$toast.error('Nenhum item selecionado')

        return false
      }

      if (this.transfJustification == '') {
        this.errorTransfJustification = 'Campo Obrigatório'

        return false
      }
      const payload = {
        accommodation_id: this.room.current_accommodation.id,
        items: this.sendItens,
        justification: this.transfJustification,
      }

      // Tenta executar diretamente - se der 403, performTransferItensOutstanding abrirá dialog
      this.performTransferItensOutstanding(payload)
    },
    addItemToSend(item) {
      if (item.checked) {
        // Adiciona se não existir
        if (!this.sendItens.find(i => i.id === item.id)) {
          this.sendItens.push(item)
        }
      } else {
        // Remove se existir
        const index = this.sendItens.findIndex(i => i.id === item.id)
        if (index > -1) {
          this.sendItens.splice(index, 1)
        }
      }
    },
    toggleSelectAll() {
      const newCheckedState = !this.allItemsSelected

      if (newCheckedState) {
        // Marcar todos
        this.transItens.forEach(item => {
          this.$set(item, 'checked', true)
          if (!this.sendItens.find(i => i.id === item.id)) {
            this.sendItens.push(item)
          }
        })
      } else {
        // Desmarcar todos
        this.transItens.forEach(item => {
          this.$set(item, 'checked', false)
        })
        this.sendItens = []
      }
    },

    // TRANSFERENCIA DE DIÁRIAS
    showTranfDiarias() {
      this.dialogTranfDiarias = true
      this.loadRooms('disponivel')
    },
    sendTransDiarias() {
      if (this.sendDiarias.length == 0) {
        this.$toast.error('Nenhuma diária selecionada')

        return false
      }
      if (this.roomId == null || this.roomId == undefined) {
        this.errorRoomTransf = 'Campo Obrigatório'

        return false
      }
      if (this.transfJustification == '') {
        this.errorTransfJustification = 'Campo Obrigatório'

        return false
      }

      const payload = {
        room_id: this.roomId,
        accommodation_id: this.room.current_accommodation.id,
        items: this.sendDiarias,
        justification: this.transfJustification,
      }

      // Tenta executar diretamente - se der 403, performTransferDiarias abrirá dialog
      this.performTransferDiarias(payload)
    },
    sendTransDiariasOutstanding() {
      if (this.sendDiarias.length == 0) {
        this.$toast.error('Nenhuma diária selecionada')

        return false
      }

      if (this.transfJustification == '') {
        this.errorTransfJustification = 'Campo Obrigatório'

        return false
      }
      const payload = {
        accommodation_id: this.room.current_accommodation.id,
        items: this.sendDiarias,
        justification: this.transfJustification,
      }

      // Tenta executar diretamente - se der 403, performTransferDiariasOutstanding abrirá dialog
      this.performTransferDiariasOutstanding(payload)
    },
    addDiariaToSend(item) {
      if (item.checked) {
        // Adiciona se não existir
        if (!this.sendDiarias.find(i => i.id === item.id)) {
          this.sendDiarias.push(item)
        }
      } else {
        // Remove se existir
        const index = this.sendDiarias.findIndex(i => i.id === item.id)
        if (index > -1) {
          this.sendDiarias.splice(index, 1)
        }
      }
    },
    toggleSelectAllDiarias() {
      const newCheckedState = !this.allDiariasSelected

      if (newCheckedState) {
        // Marcar todas
        this.transDiarias.forEach(item => {
          this.$set(item, 'checked', true)
          if (!this.sendDiarias.find(i => i.id === item.id)) {
            this.sendDiarias.push(item)
          }
        })
      } else {
        // Desmarcar todas
        this.transDiarias.forEach(item => {
          this.$set(item, 'checked', false)
        })
        this.sendDiarias = []
      }
    },
    sendTransfRoom() {
      // valida quarto
      if (this.roomId == null || this.roomId == undefined) {
        this.errorRoomTransf = 'Campo Obrigatório'

        return false
      }

      // valida a justificativa
      if (this.transfJustification == '') {
        this.errorTransfJustification = 'Campo Obrigatório'

        return false
      }

      this.loadingTransf = true
      const transf = {
        accommodation_id: this.room.current_accommodation.id,
        room_id: this.roomId,
        justification: this.transfJustification,
      }
      this.storeTransfRoom(transf)
        .then(response => {
          this.dialogTranfRoom = false
          this.roomId = ''
          this.$emit('updategrid')
          this.$emit('close')
          this.$toast.success('Transferido com sucesso')
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    showTranfItens() {
      this.dialogTranfItens = true
      this.loadRooms('disponivel')
    },
    cloneDeep(value) {
      if (value === undefined) return undefined

      return JSON.parse(JSON.stringify(value))
    },
    resetTransientState() {
      this.postedItems = []
      this.productsPrint = []
      this.product = null
      this.service = null
      this.qtyProduct = 1
      this.qtyService = 1
      this.qtyRemoveProduct = 1
      this.qtyRemoveService = 1
      this.dialogQty = false
      this.dialogQtyService = false
      this.dialogRemoveQty = false
      this.dialogRemoveQtyService = false
      this.errorQtyProduct = null
      this.errorQtyService = null
      this.errorQtyRemoveProduct = null
      this.errorQtyRemoveService = null
      this.errorObsRemoveProduct = null
      this.errorObsRemoveService = null
      this.pendingAuthorization = null
    },
    hydrateFromRoom(room, resetTransient = false) {
      if (!room || !room.current_accommodation) {
        return
      }
      if (resetTransient) {
        this.resetTransientState()
      }
      this.currentSessionAccommodationId = room.current_accommodation.id
      this.products = this.cloneDeep(room.current_accommodation.product || [])
      this.services = this.cloneDeep(room.current_accommodation.service || [])
      this.guests = this.cloneDeep(room.current_accommodation.guest || [])
      this.roomDescription = room.description
      this.licensePlate = room.current_accommodation.car_license_plate
      this.roomObs = room.current_accommodation.observation
      this.loadPostedItems()
      this.storeCheckout()
    },
    captureState() {
      return {
        products: this.cloneDeep(this.products),
        services: this.cloneDeep(this.services),
        productsPrint: this.cloneDeep(this.productsPrint),
        postedItems: this.cloneDeep(this.postedItems),
        room: {
          products: this.cloneDeep(this.room.products),
          services: this.cloneDeep(this.room.services),
          products_print: this.cloneDeep(this.room.products_print),
          posted_items: this.cloneDeep(this.room.posted_items),
          guests: this.cloneDeep(this.room.guests),
          observation: this.room.observation,
          licensePlate: this.room.licensePlate,
        },
        fields: {
          product: this.product,
          service: this.service,
          qtyProduct: this.qtyProduct,
          qtyService: this.qtyService,
          pdv: this.pdv,
          roomObs: this.roomObs,
          licensePlate: this.licensePlate,
          dialogQty: this.dialogQty,
          dialogQtyService: this.dialogQtyService,
          dialogRemoveQty: this.dialogRemoveQty,
          dialogRemoveQtyService: this.dialogRemoveQtyService,
        },
      }
    },
    restoreState(snapshot) {
      if (!snapshot) return
      this.products = snapshot.products
      this.services = snapshot.services
      this.productsPrint = snapshot.productsPrint
      this.postedItems = snapshot.postedItems
      this.product = snapshot.fields.product
      this.service = snapshot.fields.service
      this.qtyProduct = snapshot.fields.qtyProduct
      this.qtyService = snapshot.fields.qtyService
      this.pdv = snapshot.fields.pdv
      this.roomObs = snapshot.fields.roomObs
      this.licensePlate = snapshot.fields.licensePlate
      this.dialogQty = snapshot.fields.dialogQty
      this.dialogQtyService = snapshot.fields.dialogQtyService
      this.dialogRemoveQty = snapshot.fields.dialogRemoveQty
      this.dialogRemoveQtyService = snapshot.fields.dialogRemoveQtyService
      this.room.products = snapshot.room.products
      this.room.services = snapshot.room.services
      this.room.products_print = snapshot.room.products_print
      this.room.posted_items = snapshot.room.posted_items
      this.room.guests = snapshot.room.guests
      this.guests = snapshot.room.guests
      this.room.observation = snapshot.room.observation
      this.room.licensePlate = snapshot.room.licensePlate
    },

    // PRODUTOS
    dialogQtyProduct() {
      this.errorQtyProduct = null
      this.errorPdv = null
      this.dialogQty = true
    },
    addProduct() {
      const snapshot = this.captureState()

      const qty = parseInt(this.qtyProduct, 10)

      if (isNaN(qty) || qty <= 0) {
        this.errorQtyProduct = 'Quantidade deve ser um número inteiro maior que zero'

        return false
      }

      if (!this.pdv) {
        this.errorPdv = 'Selecione um ponto de venda'

        return false
      }

      this.qtyProduct = qty

      this.product.pivot = {
        quantity: 0,
      }

      this.product.pivot.quantity = this.qtyProduct
      this.productsPrint.push(this.product)

      const postedItem = {
        accommodation_id: this.room.current_accommodation_id,
        product_id: this.product.id,
        quantity: this.qtyProduct,
        pdv_id: this.pdv,
        sale_price: this.product.sale_price,
      }
      this.postedItems.push(postedItem)

      // verifica se exite o produto na lista
      const productExist = this.products.find(item => this.product.id == item.id && item.pivot.pdv_id == this.pdv)

      if (productExist) {
        productExist.pivot.quantity += this.qtyProduct
      } else {
        this.product.pivot.pdv_id = this.pdv
        this.products.push(this.product)
      }

      this.product = ''
      this.qtyProduct = 1

      this.save().catch(() => {
        this.restoreState(snapshot)
      })
    },
    addQtyProduct() {
      this.qtyProduct++
    },
    minusQtyProduct() {
      if (this.qtyProduct > 0) {
        this.qtyProduct--
      }
    },
    dialogRemoveProduct(product) {
      this.productRemove = product
      this.dialogRemoveQty = true
      this.qtyCurrentProduct = product.pivot.quantity
      this.obsRemoveProduct = ''
      this.qtyRemoveProduct = 1
      this.errorQtyRemoveProduct = null
      this.errorObsRemoveProduct = null
      this.btnQtyRemoveProduct = false
    },
    minusQtyRemoveProduct() {
      if (this.qtyRemoveProduct > 0) {
        this.qtyRemoveProduct--
      }
    },
    addQtyRemoveProduct() {
      if (this.qtyRemoveProduct < this.qtyCurrentProduct) {
        this.qtyRemoveProduct++
      }
    },
    removeProduct() {
      if (this.qtyRemoveProduct > this.qtyCurrentProduct) {
        this.errorQtyRemoveProduct = 'Quantidade retirada dever ser menor ou igual a quantidade atual'

        return
      }

      if (!this.obsRemoveProduct || !this.obsRemoveProduct.trim()) {
        this.errorObsRemoveProduct = 'Obrigatório'

        return
      }

      this.errorObsRemoveProduct = null

      // Captura estado antes de modificar (proteção contra falhas)
      const snapshot = this.captureState()

      // Modifica dados localmente de forma otimista (antes de enviar ao backend)
      const productIndex = this.products.findIndex(
        p => p.id === this.productRemove.id && p.pivot.pdv_id === this.productRemove.pivot.pdv_id,
      )

      if (productIndex !== -1) {
        this.products[productIndex].pivot.quantity -= this.qtyRemoveProduct

        // Remove produto da lista se quantidade zerou
        if (this.products[productIndex].pivot.quantity <= 0) {
          this.products.splice(productIndex, 1)
        }
      }

      const removeProduct = {
        accommodation_id: this.room.current_accommodation_id,
        product_id: this.productRemove.id,
        quantity: this.qtyRemoveProduct,
        obs: this.obsRemoveProduct,
        pdv_id: this.productRemove.pivot.pdv_id,
      }

      // Tenta executar - se falhar, restaura estado anterior
      this.performProductRemoval(removeProduct).catch(() => {
        this.restoreState(snapshot)
      })
    },
    calcTotalProduct(product) {
      return product.pivot.quantity * product.sale_price
    },

    // SERVICOS
    showDialogQtyService() {
      this.dialogQtyService = true
    },

    addQtyService() {
      this.qtyService++
    },
    minusQtyService() {
      if (this.qtyService > 0) {
        this.qtyService--
      }
    },
    addService() {
      const snapshot = this.captureState()
      if (this.qtyService == 0) {
        this.errorQtyService = 'Quantidade deve ser maior que zero'

        return false
      }
      this.service.pivot = {
        quantity: 0,
      }
      this.service.pivot.quantity = this.qtyService
      this.services.push(this.service)

      const postedItem = {
        accommodation_id: this.room.current_accommodation_id,
        service_id: this.service.id,
        quantity: this.qtyService,
        sale_price: this.service.sale_price,
      }

      this.postedItems.push(postedItem)

      this.dialogQtyService = false
      this.service = ''
      this.qtyService = 1
      this.save().catch(() => {
        this.restoreState(snapshot)
      })
    },
    calcTotalService(service) {
      return service.pivot.quantity * service.sale_price
    },
    dialogRemoveService(service) {
      this.serviceRemove = service
      this.dialogRemoveQtyService = true
      this.qtyCurrentService = service.pivot.quantity
      this.obsRemoveService = ''
      this.qtyRemoveService = 1
      this.errorQtyRemoveService = null
      this.errorObsRemoveService = null
      this.btnQtyRemoveService = false
    },
    minusQtyRemoveService() {
      if (this.qtyRemoveService > 0) {
        this.qtyRemoveService--
      }
    },
    addQtyRemoveService() {
      if (this.qtyRemoveService < this.qtyCurrentService) {
        this.qtyRemoveService++
      }
    },
    removeService() {
      if (this.qtyRemoveService > this.qtyCurrentService) {
        this.errorQtyRemoveService = 'Quantidade retirada dever ser menor ou igual a quantidade atual'

        return
      }

      if (!this.obsRemoveService || !this.obsRemoveService.trim()) {
        this.errorObsRemoveService = 'Obrigatório'

        return
      }

      this.errorObsRemoveService = null

      // Captura estado antes de modificar (proteção contra falhas)
      const snapshot = this.captureState()

      // Modifica dados localmente de forma otimista (antes de enviar ao backend)
      const serviceIndex = this.services.findIndex(
        s => s.id === this.serviceRemove.id,
      )

      if (serviceIndex !== -1) {
        this.services[serviceIndex].pivot.quantity -= this.qtyRemoveService

        // Remove serviço da lista se quantidade zerou
        if (this.services[serviceIndex].pivot.quantity <= 0) {
          this.services.splice(serviceIndex, 1)
        }
      }

      const removeService = {
        accommodation_id: this.room.current_accommodation_id,
        service_id: this.serviceRemove.id,
        quantity: this.qtyRemoveService,
        obs: this.obsRemoveService,
      }

      // Tenta executar - se falhar, restaura estado anterior
      this.performServiceRemoval(removeService).catch(() => {
        this.restoreState(snapshot)
      })
    },

    // changeQtyProduct(){
    //   if (this.qtyProduct > 0) {
    //     this.errorQtyProduct = null
    //   }
    // },
    save() {
      if (this.loading) return Promise.reject(new Error('Operação em andamento'))
      if (this.currentSessionAccommodationId !== this.room.current_accommodation_id) {
        this.$toast.error('Quarto atualizado. Reabra a conta e tente novamente.')
        this.hydrateFromRoom(this.room, true)

        return Promise.reject(new Error('Sessão de edição inválida'))
      }

      const hasInvalidPostedItems = this.postedItems.some(item => Number(item.accommodation_id) !== Number(this.room.current_accommodation_id))
      if (hasInvalidPostedItems) {
        this.$toast.error('Inconsistência ao lançar itens. Recarregue o quarto.')
        this.hydrateFromRoom(this.room, true)

        return Promise.reject(new Error('postedItems inconsistente'))
      }

      this.loading = true

      this.room.products = this.cloneDeep(this.products)
      this.room.services = this.cloneDeep(this.services)
      this.room.products_print = this.cloneDeep(this.productsPrint)
      this.room.posted_items = this.cloneDeep(this.postedItems)
      this.room.guests = this.cloneDeep(this.guests)
      this.room.observation = this.roomObs
      this.room.licensePlate = this.licensePlate
      this.editedItemLoading = true

      return this.updateRoomBusy(this.room)
        .then(response => {
          this.$emit('updategrid')

          // atualiaza os produtos do quarto no front-end
          const products = response.data.current_accommodation.product

          // this.room.current_accommodation.product = products
          // this.products = products
          this.dialogQty = false // didalog adicionar produtos
          // this.$emit('close')
          this.productsPrint = []
          this.postedItems = []
          this.$toast.success('Salvo com sucesso')
          this.storeCheckout()

          return response
        })
        .catch(error => {
          const message = error?.response?.data?.message || 'Erro ao salvar alterações'
          this.$toast.error(message)
          throw error
        })
        .finally(() => {
          this.cleanProducts()
          this.loadingAddProduct = false
          this.loading = false
          this.editedItemLoading = false
        })
    },

    saveObs() {
      this.dialogObs = false
      this.save().catch(() => {})
    },
    saveLicensePlate() {
      this.dialogChangeLicensePlate = false
      this.save().catch(() => {})
    },
    closeAccount() {
      this.$emit('close')
      this.$router.push({
        name: 'checkout',
      })
      this.setStage('payment')

      // this.setRoom(this.room)

      this.clearCheckoutSeparete()
      this.storeCheckout()
      this.setOriginPartialPayment('checkout')
    },

    partialPayment() {
      this.$emit('close')
      this.$router.push({
        name: 'checkout',
      })
      this.setStage('payment')
      this.clearCheckoutSeparete()
      this.storeCheckout()
      this.setOriginPartialPayment('accommodation')
    },

    storeCheckout() {
      this.setRoom(this.room)
      const checkoutProducts = this.products.map(product => ({
        ...product,
        origin: 'product',
      }))
      const checkoutServices = this.services.map(service => ({
        ...service,
        origin: 'service',
      }))
      const accommodationItem = (this.room.accommodationItemsCurrent || []).map(item => ({
        ...item,
        origin: 'accommodation',
        pivot: { quantity: 1 },
        sale_price: item.value,
        description: `HOSPEDAGEM ${this.formatDate(item.date_start)} - ${this.formatDate(item.date_end)}`,
      }))
      const accommodationExta = (this.room.current_accommodation.extra_items || []).map(item => ({
        ...item,
        origin: 'extra_tarif',
        pivot: { quantity: 1 },
        sale_price: item.value,
      }))
      const checkoutItems = checkoutProducts.concat(checkoutServices, accommodationItem, accommodationExta)
      this.room.tax = this.calculateRoomTax(accommodationItem)
      this.setCheckout(checkoutItems) // junta produto e servico para mostrar no checkout
    },
    calculateRoomTax(accommodationItems = []) {
      const parseNumber = value => {
        const parsed = parseFloat(value)

        return Number.isNaN(parsed) ? 0 : parsed
      }

      const serviceTax = this.services.reduce((total, service) => {
        const issPercent = parseNumber(service.iss)
        if (issPercent <= 0) {
          return total
        }
        const salePrice = parseNumber(service.sale_price)
        const quantity = parseNumber(service?.pivot?.quantity ?? 0)

        return total + (issPercent / 100) * salePrice * quantity
      }, 0)

      const withIss = this.room?.current_accommodation?.with_iss
      const applyAccommodationIss = withIss === true || withIss === 1 || withIss === '1' || withIss === 'yes' || withIss === 'true' || withIss === 'sim'
      const accommodationTax = applyAccommodationIss
        ? accommodationItems.reduce((total, item) => total + this.issRate * parseNumber(item.sale_price), 0)
        : 0

      return serviceTax + accommodationTax
    },
    status(status) {
      switch (status) {
        case 'sujo':
          return 'Sujo'
        case 'bloqueado':
          return 'Bloqueado'
        case 'diaria':
          return 'Diária'
        case 'disponivel':
          return 'Disponível'
        case 'conferencia':
          return 'Conferência'
        case 'encerramento':
          return 'Encerramento'
        case 'limpeza':
          return 'Limpeza'
        case 'manutencao':
          return 'Manutenção'
        case 'ocupado':
          return 'Ocupado'
        case 'periodo':
          return 'Período'
        case 'pernoite':
          return 'Pernoite'
        case 'reservado':
          return 'Reservado'
        case 'stand-by':
          return 'Stand-by'
      }
    },
    paymentDescription(method) {
      switch (method) {
        case 'money':
          return 'DINHEIRO'

        case 'credit_card':
          return 'CARTÃO DE CRÉDITO'

        case 'debit_card':
          return 'CARTÃO DE DÉBITO'

        case 'invoice':
          return 'FATURA'

        case 'b2b':
          return 'B2B'

        case 'transfer':
          return 'TRANSFERÊNCIA'

        case 'pix':
          return 'PIX'

        case 'other':
          return 'OUTROS'

        case 'chess_engine':
          return 'CHESS ENGINE'
      }
    },
    formatMoney(value) {
      value = parseFloat(value)
      if (value != null) {
        return value.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    },
    formatDateTime(date) {
      if (date) {
        const result = new Date(date)

        return (
          `${result.toLocaleDateString('pt-BR', {
            timeZone: 'America/Sao_Paulo',
          })
          } ${
            result.toLocaleTimeString('pt-BR')}`
        )
      }
    },
    cleanProducts() {
      const product = this.products.find(product => product.pivot.quantity == 0)
      if (product) {
        const index = this.products.indexOf(product)
        this.products.splice(index, 1)
      }
    },
    pdvDescription(pdv_id) {
      const pdv = this.getPdvs.find(pdv => pdv.id == pdv_id)

      return pdv ? pdv.description : ''
    },
    formatDate(date) {
      if (date) {
        const result = new Date(date)

        return result.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })
      }
    },
    formatHour(date) {
      if (date) {
        const result = new Date(date)

        return result.toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo' })
      }
    },

    // AUTHORIZATION
    requestAuthorization() {
      if (!this.validEmail() || !this.validPassword()) return

      const pending = this.pendingAuthorization

      if (!pending) {
        this.$toast.error('Nenhuma ação pendente para autorização')

        return
      }

      const credentials = {
        email: this.admLogin.email,
        password: this.admLogin.password,
      }

      // Não valida role - qualquer usuário com a permissão específica pode autorizar
      const validate = loginData =>

        // Backend valida as permissões específicas
        true

      const request = token => {
        switch (pending.type) {
          case 'product':
            return this.performProductRemoval(pending.payload, token)
          case 'service':
            return this.performServiceRemoval(pending.payload, token)
          case 'transfer_itens':
            return this.performTransferItens(pending.payload, token)
          case 'transfer_itens_outstanding':
            return this.performTransferItensOutstanding(pending.payload, token)
          case 'transfer_diarias':
            return this.performTransferDiarias(pending.payload, token)
          case 'transfer_diarias_outstanding':
            return this.performTransferDiariasOutstanding(pending.payload, token)
          case 'outstanding':
            return this.performOutstandingTransfer(pending.payload, token)
          case 'cancel_checkin':
            return this.performCancelCheckin(pending.payload, token)
          case 'update_accommodation_item':
            return this.performUpdateAccommodationItem(pending.payload, token)
          case 'update_extra_items':
            return this.performUpdateExtraItems(pending.payload, token)
          default:
            return Promise.resolve()
        }
      }

      this.authorizationProcessing = true

      this.runAuthorization({ credentials, validate, request })
        .then(() => {
          this.admRole.authorization = true
          this.dialogAuthorization = false
          this.pendingAuthorization = null
          this.$toast.success('Usuário autorizado')
        })
        .catch(error => {
          const message = error?.response?.data?.message || error?.message || 'Usuário não autorizado'
          this.$toast.error(message)
        })
        .finally(() => {
          this.authorizationProcessing = false
          this.admLogin.email = ''
          this.admLogin.password = ''
          this.message_error_email = ''
          this.message_error_password = ''
        })
    },
    validEmail() {
      if (this.admLogin.email === '') {
        this.message_error_email = 'Obrigatório'

        return false
      }
      this.message_error_email = ''

      return true
    },
    validPassword() {
      if (this.admLogin.password === '') {
        this.message_error_password = 'Obrigatório'

        return false
      }
      this.message_error_password = ''

      return true
    },
    cancelAuthorization() {
      this.dialogAuthorization = false
      this.pendingAuthorization = null
      this.admLogin.email = ''
      this.admLogin.password = ''
      this.message_error_email = ''
      this.message_error_password = ''
      this.authorizationProcessing = false
    },
    loadCurrentRole() {
      this.getUser().then(response => {
        if (response.data.role.name == 'Admin') {
          this.admRole.authorization = true
        } else {
          this.admRole.authorization = false
        }
      })
    },
    captureOriginalContext() {
      // Captura user_id
      this.getUser().then(response => {
        this.originalContext.user_id = response.data.id
      })

      // Captura cash_id diretamente do backend
      this.getCash().then(response => {
        if (response.data && response.data.id) {
          this.originalContext.cash_id = response.data.id
        } else {
          this.originalContext.cash_id = null
        }
      }).catch(() => {
        this.originalContext.cash_id = null
      })
    },
    addOriginalContext(payload, hasToken) {
      // Adiciona contexto original apenas quando há token temporário
      if (hasToken && this.originalContext.user_id) {
        const context = {
          ...payload,
          _original_user_id: this.originalContext.user_id,
        }

        // Só adiciona cash_id se tiver valor válido
        if (this.originalContext.cash_id) {
          context._original_cash_id = this.originalContext.cash_id
        }

        return context
      }

      return payload
    },
    queueAuthorization(type, payload = null) {
      this.pendingAuthorization = { type, payload }
      this.dialogAuthorization = true
    },
    performProductRemoval(payload, token = null) {
      this.loadingRemovedProduct = true
      this.btnQtyRemoveProduct = true

      // Adiciona room_id ao payload
      payload.room_id = this.room.id

      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        request = this.$http.post('manager_room/store_item_removed', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        request = this.storeItemRemoved(payload)
      }

      return request
        .then(response => {
          // Backend já fez TUDO em uma transação atômica
          // Atualiza dados do frontend com a resposta
          if (response.data.room) {
            this.room = response.data.room
            this.products = response.data.room.current_accommodation?.product || []
            this.services = response.data.room.current_accommodation?.service || []
            this.guests = response.data.room.current_accommodation?.guest || []
          }

          // Fecha dialog e limpa campos
          this.dialogRemoveQty = false
          this.obsRemoveProduct = ''
          this.errorObsRemoveProduct = null

          // Notifica atualização da grid
          this.$emit('updategrid')
          this.$toast.success('Produto estornado com sucesso')

          return response
        })
        .catch(error => {
          if (!token && error && error.response && error.response.status === 403) {
            this.queueAuthorization('product', payload)

            return Promise.resolve()
          }

          const msg = error?.response?.data?.error || 'Erro ao estornar produto'
          this.$toast.error(msg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingRemovedProduct = false
          this.btnQtyRemoveProduct = false
        })
    },
    performServiceRemoval(payload, token = null) {
      this.loadingRemovedService = true
      this.btnQtyRemoveService = true

      // Adiciona room_id ao payload
      payload.room_id = this.room.id

      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        request = this.$http.post('manager_room/store_item_removed', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        request = this.storeItemRemoved(payload)
      }

      return request
        .then(response => {
          // Backend já fez TUDO em uma transação atômica
          // Atualiza dados do frontend com a resposta
          if (response.data.room) {
            this.room = response.data.room
            this.products = response.data.room.current_accommodation?.product || []
            this.services = response.data.room.current_accommodation?.service || []
            this.guests = response.data.room.current_accommodation?.guest || []
          }

          // Fecha dialog
          this.dialogRemoveQtyService = false

          // Notifica atualização da grid
          this.$emit('updategrid')
          this.$toast.success('Serviço estornado com sucesso')

          return response
        })
        .catch(error => {
          if (!token && error && error.response && error.response.status === 403) {
            this.queueAuthorization('service', payload)

            return Promise.resolve()
          }

          const msg = error?.response?.data?.error || 'Erro ao estornar serviço'
          this.$toast.error(msg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingRemovedService = false
          this.btnQtyRemoveService = false
        })
    },
    performTransferItens(payload, token = null) {
      this.loadingTransf = true

      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post('manager_room/store_trans_itens', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.storeTransItens(payload)
      }

      return request
        .then(() => {
          this.dialogTranfItens = false
          this.dialogTranfRoom = false
          this.roomId = ''
          this.sendItens = []
          this.transfJustification = ''
          this.$emit('updategrid')
          this.$emit('close')
          this.$toast.success('Transferido com sucesso')
        })
        .catch(error => {
          // Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('transfer_itens', payload)

            return Promise.resolve()
          }

          // Outros erros
          const errorMsg = error?.response?.data?.error || error?.response?.data?.message || error?.response?.data || 'Erro ao transferir itens'
          this.$toast.error(errorMsg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    performTransferItensOutstanding(payload, token = null) {
      this.loadingTransf = true

      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post('manager_room/store_trans_itens_outstanding', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.storeTransItensOutstanding(payload)
      }

      return request
        .then(() => {
          this.dialogTranfItens = false
          this.dialogTranfRoom = false
          this.roomId = ''
          this.sendItens = []
          this.transfJustification = ''
          this.$emit('updategrid')
          this.$emit('close')
          this.$toast.success('Transferido com sucesso')
        })
        .catch(error => {
          // Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('transfer_itens_outstanding', payload)

            return Promise.resolve()
          }

          // Outros erros
          const errorMsg = error?.response?.data?.error || error?.response?.data?.message || error?.response?.data || 'Erro ao transferir para avulsa'
          this.$toast.error(errorMsg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    performTransferDiarias(payload, token = null) {
      this.loadingTransf = true

      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post('manager_room/store_trans_diarias', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.storeTransDiarias(payload)
      }

      return request
        .then(() => {
          this.dialogTranfDiarias = false
          this.dialogTranfRoom = false
          this.roomId = ''
          this.sendDiarias = []
          this.transfJustification = ''
          this.$emit('updategrid')
          this.$emit('close')
          this.$toast.success('Transferido com sucesso')
        })
        .catch(error => {
          // Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('transfer_diarias', payload)

            return Promise.resolve()
          }

          // Outros erros
          const errorMsg = error?.response?.data?.error || error?.response?.data?.message || error?.response?.data || 'Erro ao transferir diárias'
          this.$toast.error(errorMsg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    performTransferDiariasOutstanding(payload, token = null) {
      this.loadingTransf = true

      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post('manager_room/store_trans_diarias_outstanding', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.storeTransDiariasOutstanding(payload)
      }

      return request
        .then(() => {
          this.dialogTranfDiarias = false
          this.dialogTranfRoom = false
          this.roomId = ''
          this.sendDiarias = []
          this.transfJustification = ''
          this.$emit('updategrid')
          this.$emit('close')
          this.$toast.success('Transferido com sucesso')
        })
        .catch(error => {
          // Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('transfer_diarias_outstanding', payload)

            return Promise.resolve()
          }

          // Outros erros
          const errorMsg = error?.response?.data?.error || error?.response?.data?.message || error?.response?.data || 'Erro ao transferir para avulsa'
          this.$toast.error(errorMsg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    performOutstandingTransfer(payload, token = null) {
      this.loadingTransf = true

      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        request = this.$http.post('manager_accommodation/move_outstanding', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        request = this.storeOutstanding(payload)
      }

      return request
        .then(() => {
          this.dialogOutstanding = false
          this.dialogTranfRoom = false
          this.roomId = ''
          this.outstandingJustification = ''
          this.$emit('updategrid')
          this.$emit('close')
          this.$toast.success('Transferido com sucesso')
        })
        .catch(error => {
          if (error?.response?.status === 409 && error?.response?.data?.code === 'future_diaries') {
            return this.handleFutureDiariesPrompt(payload, token, error.response.data)
          }

          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('outstanding', payload)

            return Promise.resolve()
          }

          const errorMsg = error?.response?.data?.error || error?.response?.data?.message || error?.response?.data || 'Erro ao transferir para avulsa'
          this.$toast.error(errorMsg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    handleFutureDiariesPrompt(payload, token, data) {
      const count = data?.future_diaries_count || 0
      const dates = (data?.future_diaries || [])
        .map(item => item.date_start)
        .join(', ')

      const details = dates ? `<br><small>${dates}</small>` : ''

      return this.$swal({
        title: 'Diarias futuras encontradas',
        html: `Existem ${count} diarias futuras nesta acomodacao.${details}<br>Para continuar, escolha uma opcao: antecipar (transforma em tarifa extra) ou apagar (remove as diarias futuras).`,
        icon: 'warning',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Antecipar',
        denyButtonText: 'Apagar',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.isConfirmed) {
          return this.performOutstandingTransfer({
            ...payload,
            future_diaries_action: 'anticipate',
          }, token)
        }
        if (result.isDenied) {
          return this.performOutstandingTransfer({
            ...payload,
            future_diaries_action: 'delete',
          }, token)
        }

        return Promise.resolve()
      })
    },
    loadObservations(id) {
      this.getAccommodationObservations(id).then(
        response => {
          this.accommodation_observations = response.data
        },
      )
    },
    addObservation() {
      const observation = {
        accommodation_id: this.room.current_accommodation.id,
        description: this.onservation_input,
      }
      this.accommodation_observations.push(observation)

      const data = {
        accommodation_id: this.room.current_accommodation.id,
        observations: this.accommodation_observations,
      }

      this.updateObservations(data).then(
        () => {
          this.$toast.success('Observação adicionada')
        },
      ).catch(
        () => {
          this.$toast.error('Error no servidor')
        },
      ).finally(
        () => {
          this.dialogObsCheckout = false
          this.onservation_input = ''
        },
      )
    },
    removeObservations(item) {
      const index = this.accommodation_observations.indexOf(item)
      this.accommodation_observations.splice(index, 1)

      const data = {
        accommodation_id: this.room.current_accommodation.id,
        observations: this.accommodation_observations,
      }

      this.updateObservations(data).then(
        () => {
          this.$toast.success('Observação removida')
        },
      ).catch(
        () => {
          this.$toast.error('Error no servidor')
        },
      ).finally(
        () => {
          this.dialogObsCheckout = false
        },
      )
    },
    showDialogObsCheckout() {
      this.dialogObsCheckout = true
    },
    consumptionAlert() {
      this.alertConsumptionLimit(this.room.current_accommodation.id).then(response => {
        if (response.data.alert) {
          this.$swal({
            confirmButtonColor: '#16b1ff',
            position: 'center',
            html: '<p>' + 'Hóspede já atingiu o limite de consumo.' + '</p>',
            icon: 'warning',
            title: 'Atenção',
          })
        }
      })
    },
    showExtraDialog() {
      this.accommodation_exta = this.room.current_accommodation.extra_items
      this.dialogExtra = true
    },
    closeExtraDialog() {
      this.dialogExtra = false
    },
    addExtraItem() {
      this.accommodation_exta.push({ value: 0, description: '', type: 'additional' })
    },
    addExtraItemDiscount() {
      this.accommodation_exta.push({ value: 0, description: '', type: 'discount' })
    },
    removeExtraTariff(item) {
      const index = this.accommodation_exta.indexOf(item)
      this.accommodation_exta.splice(index, 1)
    },
    updateExtraTariff() {
      this.accommodation_exta = this.accommodation_exta.map(item => {
        if (item.type == 'additional') {
          return {
            id: item.id,
            value: item.value,
            description: item.description,
            type: item.type,
          }
        }

        return {
          id: item.id,
          value: -Math.abs(item.value),
          description: item.description,
          type: item.type,
        }
      })

      const payload = {
        accommodation_id: this.room.current_accommodation.id,
        extra_items: this.accommodation_exta,
      }

      // Tenta executar diretamente - se der 403, performUpdateExtraItems abrirá dialog
      this.performUpdateExtraItems(payload)
    },

    performUpdateExtraItems(payload, token = null) {
      // Adiciona contexto original se for autorização temporária
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post(`manager_room/update_extra_item/${payload.accommodation_id}`, payload.extra_items, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.updateExtraTarrif(payload)
      }

      return request
        .then(response => {
          this.$toast.success('Tarifas extras atualizadas com sucesso')
          this.room.current_accommodation.extra_items = response.data
          this.storeCheckout()
          this.closeExtraDialog()
        })
        .catch(error => {
          // CHAVE: Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('update_extra_items', payload)

            return Promise.resolve() // Não mostra erro, abre dialog
          }

          // Erro 422 - validação de negócio (tarifa auditada, etc)
          if (error.response?.status === 422 && error.response?.data?.error) {
            this.$toast.error(error.response.data.error)
            if (error.response.data.message) {
              this.$toast.warning(error.response.data.message)
            }

            return Promise.reject(error)
          }

          this.$toast.error('Erro ao atualizar tarifas extras')

          return Promise.reject(error)
        })
    },
    showOutstanding() {
      this.dialogOutstanding = true
    },
    moveOutstanding() {
      if (this.loadingTransf) return // proteção contra duplo clique

      if (this.outstandingJustification == '') {
        this.errorOutstandingJustification = 'Campo Obrigatório'

        return false
      }

      const payload = {
        room_category_id: this.room.room_category_id,
        room_id: this.room.id,
        description: this.room.description,
        status: 'open',
        prop: this.room.prop,
        current_accommodation_id: this.room.current_accommodation.id,
        current_reserve_id: this.room.current_reserve_id,
        status_time: new Date(),
        justification: this.outstandingJustification,
      }

      this.performOutstandingTransfer(payload)
    },
    showCancelDialog() {
      this.dialogCancel = true
    },
    sendCancelChekin() {
      // valida a justificativa
      if (this.cancelInput == '') {
        this.errorCancelInput = 'Campo Obrigatório'

        return false
      }

      const payload = {
        accommodation_id: this.room.current_accommodation.id,
        observation: this.cancelInput,
      }

      // TENTA EXECUTAR DIRETAMENTE
      this.performCancelCheckin(payload)
    },

    performCancelCheckin(payload, token = null) {
      this.loadingTransf = true

      let request
      if (token) {
        // Com autorização temporária (após 403)
        request = this.$http.post('manager_room/cancel_checkin', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa (com token do usuário atual)
        request = this.cancelCheckin(payload)
      }

      return request
        .then(response => {
          this.dialogCancel = false
          this.roomId = ''
          this.$emit('updategrid')
          this.$emit('close')
          this.$toast.success('Checkin cancelado com sucesso')
        })
        .catch(error => {
          // CHAVE: Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            this.queueAuthorization('cancel_checkin', payload)

            return Promise.resolve() // Não mostra erro, abre dialog
          }

          // Erro 422 - deixa o interceptor do axios mostrar o SweetAlert
          if (error?.response?.status === 422) {
            return Promise.reject(error)
          }

          // Outros erros (500, etc)
          this.$toast.error(error?.response?.data?.message || 'Erro ao cancelar check-in')

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    verifyReserveStatus() {
      const payload = {
        reserve_id: this.room.current_reserve_id,
        status: 'checkin',
      }
      this.updateReserve(payload)
    },
    loadPartialPayment() {
      this.partialPayments = []
      this.getPartialPayment()
        .then(response => {
          const payments = response.data
          payments.forEach(payment => {
            const data = {
              payment_item_id: payment.id,
              id: payment.pix_id,
              method: payment.method,
              value: payment.value,
              partial: true,
            }
            this.partialPayments.push(data)

            // this.addPaymentMethod(data)
          })
        })
    },
    totalPayment() {
      return this.partialPayments.reduce((acc, payment) => acc + parseFloat(payment.value), 0)
    },
    loadPostedItems() {
      this.postedProducts = []
      this.postedServices = []
      this.room.current_accommodation.posted_items.forEach(item => {
        const createdLog = item.logs.find(log => log.action === 'created')
        if (item.product) {
          this.postedProducts.push({
            id: item.id,
            description: item.product.description,
            sale_price: item.sale_price,
            quantity: item.quantity,
            total: item.sale_price * item.quantity,
            date: item.created_at,
            user: createdLog ? createdLog.user.name : null,
          })
        } else {
          this.postedServices.push({
            id: item.id,
            description: item.service.description,
            sale_price: item.sale_price,
            quantity: item.quantity,
            total: item.sale_price * item.quantity,
            date: item.created_at,
            user: createdLog ? createdLog.user.name : null,
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.custom-title {
  color: #FF4C51;
}

.hide-print-orders {
  display: none !important;
}
</style>
